import React from "react";
import bannerImg from "../../assets/images/brandings.png";
import { Link } from "react-router-dom";

function Brbanner() {
  return (
    <div>
      <section className="webbanner">
        <div className="webbanner-content">
          <h1>Branding Agency in Noida for Creative Business Growth</h1>
          <p>
            In these days’s competitive marketplace, building a robust logo
            identification is critical for long-term achievement. If you're
            searching out a dependable <b>Branding Agency in Noida</b>, you want
            a team that is aware your vision and transforms it right into a
            powerful emblem presence.
          </p>
          <div className="webbanner-cta">
            <a href="./Contact" className="webbanner-btn primary">
              Get Free Consultation →
            </a>
          </div>
        </div>
        <div className="webbanner-image">
          <img src={bannerImg}    style={{
    width: "1600px",
    height: "300px",
  }}alt="Branding Services" />

        </div>
      </section>
      <div className="breadcrumb">
        <Link to="/">Home</Link>
        <span> / </span>
        <span>Branding</span>
      </div>
    </div>
  );
}

export default Brbanner;
